var map = {
	"./icon-1.png": "aoXN",
	"./icon-2.png": "I7SW",
	"./icon-3.png": "4rPr",
	"./icon-4.png": "4WFQ",
	"./icon-5.png": "W/02",
	"./icon-6.png": "xHG/",
	"./icon-close.png": "XX6M",
	"./icon-fb.png": "K/K4",
	"./icon-l.png": "nAI9",
	"./icon-login-a.png": "RPx5",
	"./icon-login-n.png": "mjuq",
	"./icon-r.png": "MgXx",
	"./icon-reg-a.png": "KSLH",
	"./icon-reg-n.png": "7vgK",
	"./icon-tg.png": "AW7k"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sc5x";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport ^\.\/icon\-.*\.png$
// module id = sc5x
// module chunks = 0